import axios from "axios";
import { commonDocument, mediaService } from "../configs/constants";
import { message } from "antd";

const presignedImageUrl = `${mediaService}/document/getDocument`; //maintenance/getDocuments  OLD API URL
// /api/v1/document  LATEST URL FOR GET DOCUMENT API with flag ?preview=false for download
// By default preview=true
export const getPresignedImage = async (documentIdArray) => {
  const heads = {
    "organization-unit": "AGP",
    "bussiness-unit": "AUTO",
    channel: "MOBILE",
    "accept-language": "EN",
    source: "Orion",
    accept: "application/json",
    "Content-Type": "multipart/form-data",
    // 'Access-Control-Allow-Origin': 'no-cors', // Add the no-cors header
  };
  const mediaUrls = [];
  for (let documentId of documentIdArray) {
    await axios
      .get(`${presignedImageUrl}/${documentId}`, { headers: heads })
      .then((x) => {
        //   console.log("media", x);
        if (x.data?.result?.location) mediaUrls.push(x.data?.result?.location);
      })
      .catch((e) => {
        const { response } = e;
        console.log("Error", response?.message);
      });
  }
  return mediaUrls;
};

export const uploadDocumentMedia = async (payload) => {
  const url = `${mediaService}`;
  return await axios.post(url, payload, {
    headers: { "Content-Type": "application/json" },
  });
};

export const downloadDoc = async (payload) => {
  const url = `${commonDocument(payload)}`;
  return await axios.get(url, {
    headers: { "Content-Type": "application/json" },
  });
};

export const uploadToS3 = async (signedUrl, file) => {
  try {
    const response = await fetch(signedUrl, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    });
    if (response.ok) {
      message.success("File uploaded successfully to S3");
    } else {
      throw new Error("Failed to upload file");
    }
  } catch (error) {
    message.error(`Upload error: ${error.message}`);
    throw error;
  }
};

export const currencyFormat = (num, symbol?) => {
  return (
    (symbol ?? "AED ") +
    num?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  );
};

export const openFullscreen = () => {
  var elem: any = document.getElementById("myvideo");
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem?.webkitRequestFullscreen) {
    /* Safari */
    elem?.webkitRequestFullscreen();
  } else if (elem?.msRequestFullscreen) {
    /* IE11 */
    elem?.msRequestFullscreen();
  }
};

export const getMenuFeatures = (menuKey: string): any[] => {
  const menuList = JSON.parse(
    window.localStorage.getItem("menu-list") || "null"
  )?.data;
  return Array.isArray(menuList) && menuList.length > 0
    ? menuList.find((e) => e.value === menuKey)?.features || []
    : [];
};
